import { getMembershipProductV2 } from 'ui';
import type { Product } from 'services/generated/commerce-service/models/Product';
import { TRIAL, FAMILY, GIFT } from '@/lib/constants/memberships';
import { getFamilySizeFromVariant } from 'ui/utils/variantHelpers';
import {
  ANNUAL_MEMBERSHIP_KEY,
  TRIAL_MEMBERSHIP_KEY,
} from 'ui/utils/constants/membershipConstants';
import { FAMILY_MEMBERSHIP_KEY } from 'ui/utils/constants/familyConstants';

// Add membership types here when we want to roll them out
export const membershipQueryParamOptions = [TRIAL, FAMILY, GIFT];

export const getMembershipFromQueryParam = (
  membershipSearchParam: string,
  membershipsAvailable: Product[],
  sizeSearchParam?: string,
): Product | undefined => {
  // If proper skip mem select query param is present
  if (membershipQueryParamOptions.includes(membershipSearchParam)) {
    // Validate that the membership is available
    // Example : ROW flows don’t have trials, so exclude them if they come from a trials membership link
    if (membershipSearchParam === TRIAL) {
      return getMembershipProductV2(TRIAL_MEMBERSHIP_KEY, membershipsAvailable);
    }
    if (membershipSearchParam === FAMILY && sizeSearchParam) {
      // Make sure that the family membership is available
      // and that the size param corresponds to a valid family variant
      const familyProduct = getMembershipProductV2(
        FAMILY_MEMBERSHIP_KEY,
        membershipsAvailable,
      );
      const familyVariant = familyProduct?.variants.find(
        (variant) =>
          parseInt(sizeSearchParam) === getFamilySizeFromVariant(variant),
      );
      if (familyVariant) {
        return familyProduct;
      }
    }
    if (membershipSearchParam === GIFT) {
      return getMembershipProductV2(
        ANNUAL_MEMBERSHIP_KEY,
        membershipsAvailable,
      );
    }
  }
  return undefined;
};
